function Loading() {
  return (
    <div className="background-blur">
      <svg className="loader-container" viewBox="0 0 50 50" height="100" width="100">
        <circle className="loader-track" cx="25" cy="25" r="20" strokeWidth="3" fill="none" />
        <circle className="loader-car" cx="25" cy="25" r="20" strokeWidth="2" fill="none" />
      </svg>
    </div>
  );
}

export default Loading;
